import React from "react";
import "../../../components/Styles/ConsultantPendingLeadsData.css";
import { useState } from "react";
import { useEffect } from "react";
import PopUpLeadDetails from "./PopUpLeadDetails";
import PopUpLeadAssingment from "./PopUpLeadAssingment";
import swal from "sweetalert";
import { ThreeDots } from "react-loader-spinner";

const ConsultantPendingLeadsData = (props) => {
  const [seenPopUpLeadDetail, setSeenPopUpLeadDetail] = useState(false);
  const [seenPopUpLeadAssingment, setSeenPopUpLeadAssingment] = useState(false);
  const [idPopUp, setIdPopUp] = useState(1);
  const [assingmentTable, setAssingmentTable] = useState([]);
  const [loading, setLoading] = useState(false);

  const click = (e) => {
    console.log("click");
  };

  const togglePopLeadDetail = (e) => {
    setSeenPopUpLeadDetail(!seenPopUpLeadDetail);
    setIdPopUp(+e.target.value);
  };

  const togglePopLeadAssingment = (e) => {
    setSeenPopUpLeadAssingment(!seenPopUpLeadAssingment);
    setIdPopUp(+e.target.value);
  };

  const getLeadBasicData = (id) => {
    return props.leadsBasicData.filter((lead) => lead.id === id)[0];
  };

  const getLeadDetailData = (id) => {
    return props.getLeadDetailData(id);
  };

  const fetchNewLeadDelete = async (note, id) => {
    var body = {
      note: "Oznaczono do usunięcia: " + note,
      leadId: id,
    };

    await fetch("https://api.twojeskd.pl/insert_lead_delete", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.text())
      .then(async (data) => {
        swal({
          icon: "success",
          text: "Oznaczono do usunięcia",
          button: {
            text: "Ok",
          },
        }).then(async (result) => {
          setLoading(true);
          await props.refreshPage();
        });
      })
      .catch((error) => {});
  };

  const fetchNewLeadMark = async (note, leadId) => {
    var body = {
      leadId: leadId,
      note: "Oznaczono: " + note,
    };

    await fetch("https://api.twojeskd.pl/insert_lead_mark", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.text())
      .then(async (data) => {
        swal({
          icon: "success",
          text: "Oznaczono",
          button: {
            text: "Ok",
          },
        }).then(async (result) => {
          setLoading(true);
          await props.refreshPage();
        });
      })
      .catch((error) => {});
  };

  const markLeadUs = async (e) => {
    swal({
      icon: "success",
      title: "Powód",
      text: "Dodaj powód oznaczenia leada (pojawi się w notatkach)",
      content: "input",
      button: {
        text: "Dodaj",
        closeModal: true,
      },
    }).then((name) => {
      if (!name) return;
      fetchNewLeadMark(name, e.target.value);
    });
  };

  const markLead = async (e) => {
    var id = e.target.value;
    swal({
      icon: "success",
      title: "Oznacz do usunięcia",
      text: "Dodaj powód oznaczenia leada do usunięcia",
      content: "input",
      button: {
        text: "Dodaj",
        closeModal: true,
      },
    }).then(async (name) => {
      if (!name) return;
      await fetchNewLeadDelete(name, id);
    });
  };

  const fetchNewLeadDeleteUn = async (e) => {
    var body = {
      leadId: e.target.value,
    };

    await fetch("https://api.twojeskd.pl/delete_lead_delete", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.text())
      .then(async (data) => {
        swal({
          icon: "success",
          text: "Odznaczono do usunięcia",
          button: {
            text: "Ok",
          },
        }).then(async (result) => {
          setLoading(true);
          await props.refreshPage();
        });
      })
      .catch((error) => {});
  };

  const fetchNewLeadDeleteUnUs = async (e) => {
    var body = {
      leadId: e.target.value,
    };

    await fetch("https://api.twojeskd.pl/delete_lead_mark", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.text())
      .then(async (data) => {
        swal({
          icon: "success",
          text: "Odznaczono",
          button: {
            text: "Ok",
          },
        }).then(async (result) => {
          setLoading(true);
          await props.refreshPage();
        });
      })
      .catch((error) => {});
  };

  const unmarkLead = async (e) => {
    await fetchNewLeadDeleteUn(e);
  };

  const unmarkLeadUs = async (e) => {
    await fetchNewLeadDeleteUnUs(e);
  };

  const fetchLeadDelete = async (e) => {
    var body = {
      leadId: e.target.value,
    };

    await fetch("https://api.twojeskd.pl/delete_lead", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.text())
      .then(async (data) => {
        swal({
          icon: "success",
          text: "Usunięto rekord",
          button: {
            text: "Ok",
          },
        }).then(async (result) => {
          setLoading(true);
          await props.refreshPage();
        });
      })
      .catch((error) => {});
  };

  const deleteLead = async (e) => {
    await fetchLeadDelete(e);
  };

  const fetchAddNote = async (note, id) => {
    var body = {
      leadId: id,
      note: note,
    };

    await fetch("https://api.twojeskd.pl/insert_lead_note", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.text())
      .then(async (data) => {
        swal({
          icon: "success",
          text: "Dodano notatkę",
          button: {
            text: "Ok",
          },
        }).then(async (result) => {
          setLoading(true);
          await props.refreshPage();
        });
      })
      .catch((error) => {});
  };

  const fetchAddPhone = async (value, id) => {
    var leadData = props.leadsBasicData.filter((el) => +el.id === +id)[0];

    var body = {
      leadId: id,
      note: "Zmieniono numer telefonu z " + leadData.phone + " na " + value,
      phone: value,
    };

    await fetch("https://api.twojeskd.pl/update_lead_phone", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.text())
      .then(async (data) => {
        swal({
          icon: "success",
          text: "Zmieniono numer telefonu",
          button: {
            text: "Ok",
          },
        }).then(async (result) => {
          setLoading(true);
          await props.refreshPage();
        });
      })
      .catch((error) => {});
  };

  const fetchAddMail = async (value, id) => {
    var leadData = props.leadsBasicData.filter((el) => +el.id === +id)[0];

    var body = {
      leadId: id,
      note: "Zmieniono adres e-mail z " + leadData.mail + " na " + value,
      mail: value,
    };

    await fetch("https://api.twojeskd.pl/update_lead_mail", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.text())
      .then(async (data) => {
        swal({
          icon: "success",
          text: "Zmieniono adres e-mail",
          button: {
            text: "Ok",
          },
        }).then(async (result) => {
          setLoading(true);
          await props.refreshPage();
        });
      })
      .catch((error) => {});
  };

  const addNote = async (e) => {
    swal({
      icon: "success",
      title: "Notatka",
      text: "Dodaj notatkę związaną z kontaktem z klientem",
      content: "input",
      button: {
        text: "Dodaj",
        closeModal: true,
      },
    }).then((name) => {
      if (!name) return;
      fetchAddNote(name, e.target.value);
    });

    //await fetchAddNote(e);
  };

  const changePhone = async (e) => {
    swal({
      icon: "success",
      title: "Zmiana danych",
      text: "Dodaj nowy numer telefonu",
      content: "input",
      button: {
        text: "Zmień",
        closeModal: true,
      },
    }).then((name) => {
      if (!name) return;
      fetchAddPhone(name, e.target.value);
    });

    //await fetchAddNote(e);
  };

  const changeMail = async (e) => {
    swal({
      icon: "success",
      title: "Zmiana danych",
      text: "Dodaj nowy adres e-mail",
      content: "input",
      button: {
        text: "Zmień",
        closeModal: true,
      },
    }).then((name) => {
      if (!name) return;
      fetchAddMail(name, e.target.value);
    });

    //await fetchAddNote(e);
  };

  const checkIfMark = (id) => {
    var arr = props.leadsDeleteData.filter((el) => +el.userId === +id).length;

    if (arr > 0) {
      return true;
    } else {
      return false;
    }
  };

  const checkIfMarkUs = (id) => {
    var arr = props.leadsMark.filter((el) => +el.userId === +id).length;

    if (arr > 0) {
      return true;
    } else {
      return false;
    }
  };

  const leadTable = props.leadsBasicData.map((lead) => (
    <>
      <tr
        style={
          checkIfMarkUs(lead.id)
            ? { backgroundColor: "#71711f", color: "black", fontWeight: "600" }
            : checkIfMark(lead.id)
            ? { backgroundColor: "red", color: "white", fontWeight: "600" }
            : {}
        }
        key={lead.id}
      >
        <td>{lead.name}</td>
        <td>{lead.mail}</td>
        <td>{lead.phone}</td>
        <td>{lead.addDate}</td>
        <td>
          <div className="pendingLeadsDataFlexCellContainer">
            <button
              className="pendingLeadsDataButton"
              value={lead.id}
              onClick={togglePopLeadDetail}
            >
              Szczegóły
            </button>
            <button
              className="pendingLeadsDataButton"
              value={lead.id}
              onClick={togglePopLeadAssingment}
            >
              Przypisz
            </button>
            {props.user.role === 3 || props.user.role === 1 ? (
              <>
                <button
                  style={{ width: "100%" }}
                  className="pendingLeadsDataButton"
                  value={lead.id}
                  onClick={checkIfMark(lead.id) ? unmarkLead : markLead}
                >
                  {checkIfMark(lead.id)
                    ? "Odznacz do usunięcia"
                    : "Oznacz do usunięcia"}
                </button>
              </>
            ) : (
              ""
            )}
            {props.user.role === 3 || props.user.role === 1 ? (
              <>
                <button
                  style={{ width: "100%" }}
                  className="pendingLeadsDataButton"
                  value={lead.id}
                  onClick={addNote}
                >
                  {"Dodaj notatkę"}
                </button>
              </>
            ) : (
              ""
            )}
            {props.user.role === 3 || props.user.role === 1 ? (
              <>
                <button
                  style={{ width: "45%" }}
                  className="pendingLeadsDataButton"
                  value={lead.id}
                  onClick={changePhone}
                >
                  {"Zmień tel."}
                </button>
              </>
            ) : (
              ""
            )}
            {props.user.role === 3 || props.user.role === 1 ? (
              <>
                <button
                  style={{ width: "45%" }}
                  className="pendingLeadsDataButton"
                  value={lead.id}
                  onClick={changeMail}
                >
                  {"Zmień mail"}
                </button>
              </>
            ) : (
              ""
            )}
            {props.user.role === 1 ? (
              <>
                <button
                  className="pendingLeadsDataButton"
                  value={lead.id}
                  onClick={deleteLead}
                >
                  Usuń
                </button>
              </>
            ) : (
              ""
            )}
            {props.user.role === 3 || props.user.role === 1 ? (
              <>
                <button
                  style={{ width: "45%" }}
                  className="pendingLeadsDataButton"
                  value={lead.id}
                  onClick={checkIfMarkUs(lead.id) ? unmarkLeadUs : markLeadUs}
                >
                  {checkIfMarkUs(lead.id) ? "Odznacz" : "Oznacz"}
                </button>
              </>
            ) : (
              ""
            )}
          </div>
        </td>
      </tr>
    </>
  ));

  const addToAssingmentTable = (e) => {
    var arr = assingmentTable;
    arr.push(+e.target.value);
    setAssingmentTable(arr);
    swal({
      title: "Dodawanie...",
      text: "",
      icon: "info",
      timer: 1000,
      buttons: false,
    });
  };

  return (
    <>
      <div className="mainContainerConsultantpendingLeadsData">
        {loading ? (
          <ThreeDots color="black" height={50} width={50} />
        ) : (
          <>
            <table className="leadsPendingDataTable">
              <tbody>
                <tr key="header">
                  <th>Imię i nazwisko</th>
                  <th>Adres e-mail</th>
                  <th>Numer telefonu</th>
                  <th>Data dodania</th>
                  <th>Akcja</th>
                </tr>
                {leadTable}
              </tbody>
            </table>
          </>
        )}
        {seenPopUpLeadDetail ? (
          <PopUpLeadDetails
            id={idPopUp}
            toggle={togglePopLeadDetail}
            leadBasicData={getLeadBasicData(idPopUp)}
            leadDetailsData={getLeadDetailData(idPopUp)}
            leadsNote={props.leadsNote}
          />
        ) : null}
        {seenPopUpLeadAssingment ? (
          <PopUpLeadAssingment
            id={idPopUp}
            toggle={togglePopLeadAssingment}
            leadBasicData={getLeadBasicData(idPopUp)}
            leadDetailsData={getLeadDetailData(idPopUp)}
            companiesList={props.companiesList}
            assingmentTable={assingmentTable}
            addToAssingmentTable={addToAssingmentTable}
            addAssingmentsToDatabase={props.addAssingmentsToDatabase}
            companiesData={props.companiesData}
            leadsNote={props.leadsNote}
            refreshPage={props.refreshPage}
          />
        ) : null}
      </div>
    </>
  );
};

export default ConsultantPendingLeadsData;
